import React from 'react';
import ProgressRing from './ProgressRing';
import { formatEventDate } from '../utils/eventDisplay';

function ClientPlannerHeader({event,completion,saved}) {
  return (
    <header className="client-planner-header">
      <div className="client-planner-heading">
        <span className="eyebrow">Private client portal</span>
        <h1>{event.name}</h1>
        <p>{formatEventDate(event.date)} <span>·</span> {event.venue}</p>
      </div>

      <div className="client-planner-status">
        <ProgressRing value={completion} size={64} />
        <div>
          <strong>Event planner</strong>
          <span>{completion}% complete</span>
          <small className={saved ? 'saved' : ''}>
            {saved ? 'All changes saved' : 'Saving changes...'}
          </small>
        </div>
      </div>
    </header>
  );
}

export default ClientPlannerHeader;